/* eslint-disable import/prefer-default-export */

import { API_URL } from '../../../../../../../utils/config';

export const DUMMY_URL = `${API_URL}/dummy`;
